import api from '@shared/services/api';

export const getBankAccounts = async (firmId) => {
    const response = await api.get(`/firm-bank-account/company/${firmId}`);
    return response.data;
};

export const createBankAccount = async (data) => {
    const response = await api.post('/firm-bank-account', data);
    return response.data;
};

export const deleteBankAccount = async (id) => {
    const response = await api.delete(`/firm-bank-account/${id}`);
    return response.data;
};

export const updateBankAccount = async (id, data) => {
    const response = await api.put(`/firm-bank-account/${id}`, data);
    return response.data;
};
